export default __webpack_public_path__ + "static/media/677.e878757c.png";